export default __webpack_public_path__ + "static/media/logo.b372a9c0.png";